import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { isAuthenticated } from "../Utilities/Auth";

const PublicRoutes = () => {
    if(isAuthenticated()){
        return <Navigate to="/dashboard" replace />;
    }
    return <Outlet/>
};

export default PublicRoutes;